import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { AttachmentUploader } from "../../../components/lifecycle/attachmentUploader";
import { AttachmentList } from "../../../components/lifecycle/attachmentsList";
import { LifecycleAttachmentApi } from "../../../components/lifecycle/types";
import { counterpartyAttachmentApi } from "../../tradingCounterparties/dataHooks/attachmentQueries";
import { brokerAttachmentApi } from "../../brokers/dataHooks/attachmentQueries";
import { EntityKind } from "../../../utils/entityPaths";

/** Merger documents live in the entity's own attachment store, under this folder. */
export const MERGER_ATTACHMENT_FOLDER = "merger";

export const mergerAttachmentApi = (
  kind: EntityKind
): LifecycleAttachmentApi =>
  kind === "counterparty" ? counterpartyAttachmentApi : brokerAttachmentApi;

type Props = {
  kind: EntityKind;
  entityId: string;
  /** Show the uploader. Without it the list is read-only apart from its own delete gate. */
  canUpload?: boolean;
};

export const MergerAttachments: FC<Props> = ({
  kind,
  entityId,
  canUpload = false
}) => {
  const attachmentApi = mergerAttachmentApi(kind);
  // A hook, called unconditionally; kind never changes for a mounted entity.
  const { data: attachments = [] } = attachmentApi.useList(
    entityId,
    MERGER_ATTACHMENT_FOLDER
  );

  return (
    <Box>
      {canUpload && (
        <AttachmentUploader
          entityId={entityId}
          lifecycleName={MERGER_ATTACHMENT_FOLDER}
          attachmentApi={attachmentApi}
        />
      )}
      {attachments.length > 0 ? (
        <AttachmentList
          entityId={entityId}
          lifecycleName={MERGER_ATTACHMENT_FOLDER}
          attachments={attachments}
          attachmentApi={attachmentApi}
        />
      ) : (
        !canUpload && (
          <Typography variant="body2" color="text.secondary">
            No merger documents.
          </Typography>
        )
      )}
    </Box>
  );
};
